import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Hero, SectionWidget, QuickLinks, UnderDev } from '../blocks/all-blocks';
import '../styles/creations.css';

const Creations = ({ transfile }) => {
  const { t } = useTranslation();
  const [displayMethod, setDisplayMethod] = useState(true);

  const recentNine = [];

  const quickLinks = [
    { name: t('quickLinks.knowledge'), url: '/knowledge' },
    { name: t('quickLinks.tools'), url: '/tools' },
    { name: t('quickLinks.aboutMe'), url: '/me' }
  ];

  return (
    <div className="cont-body">
      <Hero translation={transfile}/>
      <UnderDev />
      <SectionWidget sectionName={t('recentCreations')} recentNine={recentNine} url='/notes' displayMethod={displayMethod} setDisplayMethod={setDisplayMethod} defaultItemsShowed={9}/>
      <QuickLinks list={quickLinks} />
    </div>
  );
};

export default Creations;